/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Why_2_DInputs */

const en_cp_why_2_d = /** @type {(inputs: Cp_Why_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phase approvals, evidence ratio, and exceptions are recorded all semester — not a report written on the last night.`)
};

const id_cp_why_2_d = /** @type {(inputs: Cp_Why_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persetujuan fase, rasio bukti, dan pengecualian terekam sepanjang semester — bukan laporan yang ditulis di malam terakhir.`)
};

/**
* | output |
* | --- |
* | "Phase approvals, evidence ratio, and exceptions are recorded all semester — not a report written on the last night." |
*
* @param {Cp_Why_2_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_why_2_d = /** @type {((inputs?: Cp_Why_2_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Why_2_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_why_2_d(inputs)
	return en_cp_why_2_d(inputs)
});